import { NEW_BASE_URL } from "../Constant";
import { newReconServiceAPI } from "./APIutils";

export function fetchAllOperatorsPassRevenue({
  pageNo,
  pageSize = 10,
  cityFilter = [],
  operatorFilter = [],
  dateFilter: { fromDate = "", toDate = "" } = {},
}) {
  const url = `${NEW_BASE_URL}/v1/reconReports/passRevenueDetails`;
  return newReconServiceAPI(url, {
    pageNo,
    pageSize,
    cityIdArr: cityFilter,
    operatorIdArr: operatorFilter,
    fromDate,
    toDate,
  });
}
export function createOperatorPassRevenue({
  cityId,
  operatorId,
  date = "",
  passRevenueDetails: { superSaverPassRevenue = 0, magicPassRevenue = 0 } = {},
}) {
  const url = `${NEW_BASE_URL}/v1/reconReports/addPassRevenue`;
  return newReconServiceAPI(url, {
    cityId,
    operatorId,
    date,
    passRevenueDetails: { superSaverPassRevenue, magicPassRevenue },

  });
}

export function fetchAllPassRevenueCities() {
  const url = `${NEW_BASE_URL}/v1/reconReports/viewManualPassRevenueCities`;
  return newReconServiceAPI(url, {
  });
}

export function passRevenueUploadExcelFile(data) {
  const url = `${NEW_BASE_URL}/v1/reconReports/uploadPassRevenue`;
  return newReconServiceAPI(url, {
    ...data,
  });
}
